// Client campaign photography.

// Story images (named per section by the client).
export const STORY = {
  transform1:
    "https://customer-assets.emergentagent.com/job_projection-luxe/artifacts/np0yc6uk_Transforming%20buildings%20into%20brand%20experiences.jpeg",
  transform2:
    "https://customer-assets.emergentagent.com/job_projection-luxe/artifacts/1flqp1ea_Transforming%20Building%20into%20brand%20experiences%201.jpeg",
  architecture:
    "https://customer-assets.emergentagent.com/job_projection-luxe/artifacts/axxt1j48_Architecture%20becomes%20Media.jpeg",
  city1:
    "https://customer-assets.emergentagent.com/job_projection-luxe/artifacts/dn33pnzm_The%20City%20is%20your%20canvas.jpeg",
  city2:
    "https://customer-assets.emergentagent.com/job_projection-luxe/artifacts/qx7puvlv_The%20city%20is%20your%20canvas%20%282%29.jpeg",
};

// Individually identified campaign photographs.
export const IMG = {
  cartier:
    "https://customer-assets.emergentagent.com/job_projection-luxe/artifacts/pg69q3q3_WhatsApp%20Image%202026-05-18%20at%2016.29.23.jpeg",
  leviLondon:
    "https://customer-assets.emergentagent.com/job_projection-luxe/artifacts/doivg0v0_WhatsApp%20Image%202026-05-18%20at%2016.29.31.jpeg",
  leviHamburg:
    "https://customer-assets.emergentagent.com/job_projection-luxe/artifacts/1v1cs9pz_WhatsApp%20Image%202026-05-18%20at%2016.29.31%20%282%29.jpeg",
  ramsay:
    "https://customer-assets.emergentagent.com/job_projection-luxe/artifacts/4rhl46tr_WhatsApp%20Image%202026-05-18%20at%2016.29.26%20%281%29.jpeg",
  esprit:
    "https://customer-assets.emergentagent.com/job_projection-luxe/artifacts/v4wzxoy5_WhatsApp%20Image%202026-05-18%20at%2016.29.13.jpeg",
  oura: "https://customer-assets.emergentagent.com/job_projection-luxe/artifacts/qx7puvlv_The%20city%20is%20your%20canvas%20%282%29.jpeg",
  sela: "https://customer-assets.emergentagent.com/job_projection-luxe/artifacts/xmt4cy7q_WhatsApp%20Image%202026-05-22%20at%2015.46.13.jpeg",
  cider:
    "https://customer-assets.emergentagent.com/job_projection-luxe/artifacts/4mq67ab0_WhatsApp%20Image%202026-05-18%20at%2016.29.32%20%282%29.jpeg",
  dyson:
    "https://customer-assets.emergentagent.com/job_projection-luxe/artifacts/devpex1u_WhatsApp%20Image%202026-05-22%20at%2015.51.43.jpeg",
  tate: "https://customer-assets.emergentagent.com/job_projection-luxe/artifacts/gm03nmy4_WhatsApp%20Image%202026-05-22%20at%2015.51.41%20%281%29.jpeg",
  dysonWide:
    "https://customer-assets.emergentagent.com/job_projection-luxe/artifacts/w7td040c_WhatsApp%20Image%202026-05-22%20at%2015.51.43.jpeg",
};

import marbleArch from "./assets/marble-arch.jpg";
import brickLane from "./assets/brick-lane.jpg";
import ensoPoster from "./assets/enso-poster.jpg";
import live1 from "./assets/live-1.jpg";
import live2 from "./assets/live-2.jpg";
import live3 from "./assets/live-3.jpg";
import live4 from "./assets/live-4.jpg";

// Hero background — Brick Lane projection photograph (client upload).
export const HERO_BG = brickLane;

// ENSO × Brick Lane — adapted 16:9 website video + poster frame.
export const ENSO_VIDEO = "/videos/enso-portrait.mp4";
export const ENSO_POSTER = ensoPoster;

// Live Event Projection — client uploads, rotated upright (IMG_9272/73/85/91).
export const LIVE_IMG = {
  live1,
  live2,
  live3,
  live4,
};

// Marble Arch hero photograph (cropped from the client's design mockup).
export const MARBLE_ARCH = marbleArch;

// Additional project gallery photography (client uploads, named per campaign).
export const PROJECT_IMG = {
  cartier1:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_projection-luxe/artifacts/kpmytq2d_CARTIER%201.jpeg",
  levis5:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_projection-luxe/artifacts/ttent2lh_LEVIS%205.jpeg",
  dyson4:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_projection-luxe/artifacts/40hv3es7_DYSON%204.jpeg",
  esprit2:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_projection-luxe/artifacts/bn3tqsn1_ESPRIT2.jpeg",
  newBalance1:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_projection-luxe/artifacts/prprrf8w_NEW%20BALANCE%201.jpg",
  newBalance2:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_projection-luxe/artifacts/e31eruep_NEW%20BALANCE%202.jpg",
  dysonArch:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_projection-luxe/artifacts/ri69qdco_DYSON.webp",
};

// WHAT WE DO service-card photography (client uploads, named per service).
export const SERVICE_IMG = {
  advertising: brickLane,
  mapping: ensoPoster,
  immersive: live4,
  live: live1,
  installations: live2,
};

export const WHYUS_BG =
  "https://static.prod-images.emergentagent.com/jobs/8d34599e-f131-4f75-a3b5-dfe93946fed9/images/eff2ceff028b0c7178d924d1d8d2c2f33249f0f2b328a74d46449d7b572af0f7.png";

export const INSTAGRAM_URL = "https://www.instagram.com/luminart.projection/";

export const ACCENT = "#c8b99d";
